




































































































































































import {Component, Emit, Vue} from 'vue-property-decorator';
import ButtonPanel from '@/components/menu/panel/ButtonPanel.vue';
import IconButton from '@/components/atom/button/IconButton.vue';
import NormalDialog from '@/components/atom/dialog/NormalDialog.vue';
import moment from 'moment';
import otaruDestroyApi from '@/infrastructure/api/custom/otaru/OtaruDestroyApi.ts';
import {期限切れ破棄破損採用品型} from '@/type/custom/otaru/destroy/item.ts';
import {期限切れ破棄破損採用品一覧型} from '@/type/custom/otaru/destroy/itemList.ts';
import {検索条件初期値, 検索条件型} from '@/type/custom/otaru/destroy/searchCriteria';
import AlertDialog from '@/components/atom/dialog/AlertDialog.vue';

@Component({
  components: {
    ButtonPanel,
    IconButton,
    NormalDialog,
    AlertDialog,
  },
  filters: {
    日付フォーマット(date: Date): string {
      if (date == null) {
        return '';
      }
      return moment(date).format('YYYY/MM/DD');
    },
    floatPriceFormat(value: number): string {
      if (!value) {
        return '';
      }
      return value.toLocaleString('ja-JP', {minimumFractionDigits: 3});
    },
    priceFormat(value: number): string {
      if (!value) {
        return '';
      }
      return value.toLocaleString('ja-JP', {minimumFractionDigits: 0});
    },
  },
})
export default class OtaruSearchDestroyItemDialog extends Vue {

  検索条件: 検索条件型 = 検索条件初期値();

  選択行番号: number | null = null;

  期限切れ破棄破損採用品一覧: 期限切れ破棄破損採用品型[] = [];
  アラートメッセージ: string[] | string | null = null;

  @Emit('item-search-close')
  閉じる() {
    this.期限切れ破棄破損採用品一覧 = [];
    this.選択行番号 = null;
    return;
  }

  行が選択されている(行番号: number) {
    if (this.選択行番号 === null) return false;
    return this.選択行番号 === 行番号;
  }

  行を選択する(行番号: number): void {
    this.選択行番号 = 行番号;
  }

  確定する(): void {
    if (this.選択行番号 === null) return;
    const 期限切れ破棄破損採用品 = this.期限切れ破棄破損採用品一覧.filter((it, index) => this.選択行番号 === index)[0];

    this.fireCompleteEvent(期限切れ破棄破損採用品);
    this.期限切れ破棄破損採用品一覧 = [];
    this.選択行番号 = null;
  }

  // events
  @Emit('complete')
  fireCompleteEvent(期限切れ破棄破損採用品: 期限切れ破棄破損採用品型): 期限切れ破棄破損採用品型 {
    return 期限切れ破棄破損採用品;
  }

  async 検索する() {
    await otaruDestroyApi.期限切れ破棄破損採用品を検索する(this.検索条件)
      .then((response) => {
        const 検索上限値付き期限切れ破棄破損採用品一覧 = response;
        this.期限切れ破棄破損採用品一覧 = 検索上限値付き期限切れ破棄破損採用品一覧.期限切れ破棄破損採用品一覧;
        if (this.期限切れ破棄破損採用品一覧.length === 0) {
          this.showAlert('検索結果が0件です。');
          return;
        }
        if (検索上限値付き期限切れ破棄破損採用品一覧.アラートメッセージ) {
          this.showAlert(検索上限値付き期限切れ破棄破損採用品一覧.アラートメッセージ);
          return;
        }
      })
      .catch((error: any) => {
        this.showAlert(error.data.message);
      });
  }

  showAlert(message: string[] | string | null): void {
    this.アラートメッセージ = message;
    this.$modal.show('商品選択アラート');
  }
}

